var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 388,
    viewBox: "0 0 347 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.784 0.784372C260.245 -4.74466 272.563 61.3381 308.751 167.71C344.939 274.083 378.529 295.501 294.387 367.113C210.245 438.725 -11.6603 307.473 0.632584 222.356C12.9255 137.24 67.3235 6.3134 163.784 0.784372Z",
    fill: "#F0E3CA",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot2);
export default __webpack_public_path__ + "static/media/spot2.55c7fcae68d7aac230504ddf06d51cd5.svg";
export { ForwardRef as ReactComponent };